import script from "./LeaderProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjects.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjects.vue?vue&type=style&index=0&id=390501fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390501fa"]])

export default __exports__